<script>
import { mapState } from 'vuex';

import FlashMessage from './flash_message.vue';

export default {
  components: {
    FlashMessage
  },

  emits: ['show'],

  data() {
    return {
      isVisible: !!this.$store.state.cancelMessage
    };
  },

  computed: {
    ...mapState([
      'cancelMessage',
    ])
  },

  mounted() {
    if (this.isVisible) { this.$emit('show'); }
  },

  methods: {
    setInvisible() {
      this.isVisible = false;
    }
  }
};
</script>

<template>
  <flash-message
    :message="cancelMessage"
    :show="isVisible"
    type="error"
    @close="setInvisible"
  />
</template>
